module.exports = __webpack_public_path__ + "img/65ru.2d09a6bf.png";